export const FETCH_ERROR = 'error/fetch-error'
export const REDIRECT = 'error/should-redirect'
